import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 1164px;
  margin-right: auto;
  margin-left: auto;
`;
